<template>
  <div :class="previewClass">
    <div id="pdf-ui" class="viewer-container"></div>
  </div>
</template>

<script>
import "@/assets/foxit/adaptive.js";
import "@/assets/foxit/preload-jr-worker.js";
import "@/assets/foxit/UIExtension.full.js";
import { config } from "@/config/index";
export default {
  name: "pdfPreview",
  data() {
    return {};
  },
  computed: {
    previewData() {
      return this.$store.state.drive.previewData;
    },
    previewClass() {
      return "preview-" + this.$store.state.drive.previewData.position;
    },
  },
  created() {
    // console.log("初始化pdf预览组件");
  },
  mounted() {
    const licenseSN = process.env.VUE_APP_FOXIT_LICENSE_SN;
    const licenseKey = process.env.VUE_APP_FOXIT_LICENSE_KEY;
    const readyWorker = preloadJrWorker({
      workerPath: config.url + "/foxit-lib/",
      enginePath: config.url + "/foxit-lib/jr-engine/gsdk",
      fontPath: config.url + "/external/brotli",
      licenseSN: licenseSN,
      licenseKey: licenseKey,
      // l: license,
    });
    fetch(
      UIExtension.PDFViewCtrl.DeviceInfo.isMobile
        ? `${config.url}/foxit-lib/built-in-mobile-layout-template-preview.tpl`
        : `${config.url}/foxit-lib/built-in-pc-layout-template-preview.tpl`
    )
      .then(function (response) {
        return response.text();
      })
      .then((template) => {
        // const Events = UIExtension.PDFViewCtrl.Events;
        this.pdfui = window.pdfui = new UIExtension.PDFUI({
          i18n: {
            absolutePath: config.url + "/foxit-lib/locales",
            lng: "zh-CN",
          },
          viewerOptions: {
            libPath: config.url + "/foxit-lib",
            jr: {
              readyWorker: readyWorker,
              licenseSN: licenseSN,
              licenseKey: licenseKey,
            },
          },
          renderTo: "#pdf-ui",
          appearance: UIExtension.appearances.adaptive,
          template: template,
          // template: `<webpdf><viewer></viewer></webpdf>`,
          fragments: "view",
          addons: [
            config.url + "/foxit-lib/uix-addons/file-property",
            config.url + "/foxit-lib/uix-addons/multi-media",
            config.url + "/foxit-lib/uix-addons/password-protect",
            config.url + "/foxit-lib/uix-addons/redaction",
            config.url + "/foxit-lib/uix-addons/path-objects",
            config.url + "/foxit-lib/uix-addons/print",
            config.url + "/foxit-lib/uix-addons/full-screen",
            config.url + "/foxit-lib/uix-addons/import-form",
            config.url + "/foxit-lib/uix-addons/export-form",
            config.url + "/foxit-lib/uix-addons/undo-redo",
            config.url + "/foxit-lib/uix-addons/thumbnail",
            config.url + "/foxit-lib/uix-addons/h-continuous",
          ].concat(
            UIExtension.PDFViewCtrl.DeviceInfo.isMobile
              ? []
              : [
                  config.url + "/foxit-lib/uix-addons/text-object",
                  config.url + "/foxit-lib/uix-addons/form-designer",
                  config.url + "/foxit-lib/uix-addons/recognition-form",
                ]
          ),
        });

        // 加载文件
        fetch(this.previewData.preview_path).then((response) => {
          response.arrayBuffer().then((buffer) => {
            this.pdfui.openPDFByFile(buffer);
          });
        });

        window.addEventListener(
          UIExtension.PDFViewCtrl.DeviceInfo.isDesktop
            ? "resize"
            : "orientationchange",
          function (e) {
            this.pdfui.redraw().catch(function (err) {
              console.log(err);
            });
          }
        );
        this.pdfui.addUIEventListener(
          "fullscreenchange",
          function (isFullscreen) {
            if (isFullscreen) {
              document.body.classList.add("fv__pdfui-fullscreen-mode");
            } else {
              document.body.classList.remove("fv__pdfui-fullscreen-mode");
            }
          }
        );
        // 下方的代码仅在打开本地/URL文件时适用，如无需打开文件，下面代码可删除
        // function openLoadingLayer() {
        //   return window.pdfui.loading();
        // }
        // const loadingComponentPromise = openLoadingLayer();

        // window.pdfui.addViewerEventListener(Events.beforeOpenFile, function () {
        //   if (loadingComponentPromise) {
        //     loadingComponentPromise = loadingComponentPromise
        //       .then(function (component) {
        //         component.close();
        //       })
        //       .then(openLoadingLayer);
        //   } else {
        //     loadingComponentPromise = openLoadingLayer();
        //   }
        // });
        // window.pdfui.addViewerEventListener(
        //   Events.openFileSuccess,
        //   function () {
        //     loadingComponentPromise.then(function (component) {
        //       component.close();
        //     });
        //   }
        // );
        // window.pdfui.addViewerEventListener(Events.openFileFailed, function () {
        //   loadingComponentPromise.then(function (component) {
        //     component.close();
        //   });
        // });
      });
  },
  destroyed() {
    // console.log("销毁pdf预览组件");
  },
};
</script>

<style scoped>
@import "../assets/foxit/UIExtension.css";
@import "../assets/foxit/index.css";
.preview-fullscreen {
  width: 100%;
  height: 100%;
}
.preview-fullscreen-top {
  width: 100%;
  height: 100%;
}
.preview-inside {
  width: 460px;
  height: 280px;
}
</style>